import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import { withStyles } from 'tss-react/mui';

import { withDisplaying } from '../../hoc';
import BodySupplies from './BodySupplies';
import withExpansionPanel from '../../hoc/withExpansionPanel';

const styles = () => ({
  root: {
    width: '100%',
  },
});

const ExpansionSupplies = withExpansionPanel(BodySupplies);

const Supplies = ({ classes, ...props }) => (
  <div className={classes.root}>
    <ExpansionSupplies expansionTitle={'Fournitures'} {...props} />
  </div>
);

Supplies.propTypes = {
  value: PropTypes.instanceOf(List).isRequired,
  setData: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};

Supplies.defaultProps = {
  value: new List([]),
  readOnly: false,
};

Supplies.displayName = 'Supplies';

export default withDisplaying()(withStyles(Supplies, styles));
